// Wspólny transition przejść między ekranami — jedno źródło prawdy dla Page i PageTestPage.
// Fade + lift z ease-out (szybki start, miękkie lądowanie), exit krótszy niż enter.
// prefers-reduced-motion: sam fade, zero ruchu i scale.

export const getPageTransitionProps = (prefersReducedMotion, disableExit = false) => {
  if (prefersReducedMotion) {
    return {
      initial: { opacity: 0 },
      animate: { opacity: 1, transition: { duration: 0.2 } },
      exit: disableExit ? undefined : { opacity: 0, transition: { duration: 0.12 } },
    };
  }

  // Bez scale i bez springa: spring dopinal koncowke skokiem po "spoczynku", a scale
  // rozmywal tekst, ktory na koniec przeskakiwal na ostry — widoczne mignięcie po wejściu.
  return {
    initial: { opacity: 0, y: 12 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.32, ease: [0.22, 1, 0.36, 1] },
    },
    exit: disableExit
      ? undefined
      : {
          opacity: 0,
          y: -6,
          transition: { duration: 0.16, ease: [0.4, 0, 1, 1] },
        },
  };
};

// Element dochodzący w trakcie zadania (np. widget comebacku / reality check).
export const getRevealProps = (prefersReducedMotion) => (
  prefersReducedMotion
    ? {
        initial: { opacity: 0 },
        animate: { opacity: 1, transition: { duration: 0.2 } },
        exit: { opacity: 0, transition: { duration: 0.12 } },
      }
    : {
        initial: { opacity: 0, y: 10 },
        animate: { opacity: 1, y: 0, transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] } },
        exit: { opacity: 0, transition: { duration: 0.15 } },
      }
);

// Przejście między kolejnymi zadaniami (SolveProblem / SolveSurefire / ExamSheetResolver).
// Ta sama rodzina co nawigacja, lekko spokojniejsza. Też bez springa i scale (mignięcie na końcu).
// Zwraca mapę variants (initial/animate/exit) — używane z initial="initial" animate="animate" exit="exit".
export const getProblemTransitionVariants = (prefersReducedMotion) => {
  if (prefersReducedMotion) {
    return {
      initial: { opacity: 0 },
      animate: { opacity: 1, transition: { duration: 0.3 } },
      exit: { opacity: 0, transition: { duration: 0.18 } },
    };
  }

  return {
    initial: { opacity: 0, y: 14 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.38, ease: [0.22, 1, 0.36, 1] },
    },
    exit: {
      opacity: 0,
      y: -8,
      transition: { duration: 0.22, ease: [0.4, 0, 1, 1] },
    },
  };
};
